import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-white py-16 border-t border-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="text-center md:text-left">
            <span className="text-2xl font-black text-slate-900 tracking-tighter">Per Olkjær Nielsen</span>
            <p className="text-sm text-slate-400 mt-2 font-medium uppercase tracking-widest">Digital Ledelse & Strategisk Indhold</p>
          </div>
          
          <div className="flex items-center space-x-8">
            <a href="mailto:olkjaer@hotmail.com" className="group flex items-center text-slate-600 hover:text-slate-900 transition-colors">
              <SafeIcon name="Mail" className="h-5 w-5 mr-2 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-semibold">olkjaer@hotmail.com</span>
            </a>
            <div className="h-4 w-px bg-stone-200 hidden sm:block" />
            <a 
              href="https://www.linkedin.com/in/perolkjaer/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-2 bg-stone-50 rounded-full text-slate-400 hover:text-slate-900 hover:bg-stone-100 transition-all"
            >
              <SafeIcon name="Linkedin" className="h-6 w-6" />
            </a>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-stone-50 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs font-medium text-slate-400 uppercase tracking-widest">
          <p>&copy; {new Date().getFullYear()} Per Olkjær Nielsen</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;